<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Informe De Pólizas Por Renovar
            <ModalTableComponent :open="obModal.open" :titulo="obModal.titulo" :listGeneral="listGeneral"/>
        </v-card-title>
        <v-container fluid grid-list-sm>

            <v-row dense>
                <v-col cols="12" sm="3" class="mt-8">
                    <v-dialog ref="dialogFechaDesde" v-model="abrirModalDesde"
                        :return-value.sync="obSearch.fechaDesde" persistent width="330px">
                        <template v-slot:activator="{ on }">
                            <v-text-field color="textbox" v-model="obSearch.fechaDesde" label="Fecha Corte*"
                                prepend-inner-icon="event" readonly outlined dense v-on="on" />
                        </template>
                        <v-date-picker color="primary" v-model="obSearch.fechaDesde" scrollable locale="es">
                            <v-spacer></v-spacer>
                            <v-btn outlined dense rounded color="danger" @click="abrirModalDesde = false" v-html="'Salir'"></v-btn>
                            <v-btn rounded dark color="primary"
                                @click="$refs.dialogFechaDesde.save(obSearch.fechaDesde);" v-html="'Guardar Fecha'">
                            </v-btn>
                        </v-date-picker>
                    </v-dialog>
                </v-col>

                <v-col cols="12" sm="3" class="mt-8">
                    <v-autocomplete label="Canal *" color="textbox" v-model="obSearch.idCanal"
                        :items="listGeneral.listCanal" outlined dense />
                </v-col>

                <v-col cols="12" sm="3" class="mt-8">
                    <v-autocomplete label="Dias por Vencer *" color="textbox" v-model="obSearch.diasVencer"
                        :items="listGeneral.listDiasVencer" outlined dense />
                </v-col>

                <v-col cols="12" sm="3">
                    <v-radio-group v-model="idTipoBusqueda" dense>
                        <v-radio label="Póliza" value="P" ></v-radio>
                        <v-radio label="Certificado" value="C" ></v-radio>
                    </v-radio-group>
                </v-col>
                
            </v-row>

            <v-row dense>
                <v-col cols="12" sm="9"/>
                <v-col cols="12" sm="3" class="text-right">
                    <v-tooltip bottom color="primary">
                        <template v-slot:activator="{ on }">
                            <v-btn fab dark small color="primary" @click="onListar" v-on="on"
                                    :disabled="disabled">
                                    <v-icon dark>search</v-icon>
                            </v-btn>
                        </template>
                        <span>Buscar</span>
                    </v-tooltip>
                </v-col>
            </v-row>

            <v-row dense justify="space-between">
                <!-- <v-col cols="12" sm="12"> -->
                    <v-checkbox label="Agrupar por Seguro" v-model="group" dense color="primary"></v-checkbox>
                    <v-switch label="Ver Resumen Total de Pólizas a Vencer" v-model="showDet" dense color="primary"></v-switch>
                <!-- </v-col> -->
            </v-row>

            <v-row dense>
                <v-col v-if="_.size(listGeneral.listDetalle) == 0" cols="12" sm="6"></v-col>
                <v-col v-else cols="12" sm="6">
                    <v-btn rounded color="primary" dark @click="exportar('tableBeneCom','Tasas')">Exportar a XLSX</v-btn>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field label="Buscar" color="textbox" v-model="obSearch.search" clearable dense
                        prepend-inner-icon="search" />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12">
                    <v-data-table :search="obSearch.search" :headers="cabecera" id="tableBeneCom"  :group-by="group ? ['seguro']: []"
                        :items="listGeneral.listDetalle" class="elevation-3">

                        <template v-slot:body.append>
                            <tr v-show="_.size(listGeneral.listDetalle) > 0 && idTipoBusqueda != 'P'">
                                    <td v-show="!group"></td>
                                    <td :colspan="colspan"></td>
                                    <td > <span class="font-weight-black" v-html="'Total'"></span></td>
                                    <td><span class="font-weight-black" v-html="totalAsegurado"> </span></td>
                                    <td><span class="font-weight-black" v-html="totalPrima"> </span></td>
                            </tr>
                        </template>

                        <template v-slot:no-results>
                            Tu búsqueda de "<span v-html="obSearch.search"></span>" no arrojó resultados.
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    export default {
        name: 'InformePolizaRenovarView',
        components:{
            ModalTableComponent: () => import('@/components/consulta/informe/ModalTableComponent.vue')
        },
        data: () => ({
            group:false,
            showDet:false,
            disabled:false,
            abrirModalDesde:false,
            idTipoBusqueda:'P',
            obModal:{
                titulo:'Resumen Total de Pólizas a Vencer',
                open:false
            },
            obSearch:{
                search:'',
                fechaDesde:moment().format('YYYY-MM-DD'),
                diasVencer:null,
                idCanal:null,
                idEstado:null,
            },
            listGeneral:{},
            parametros:{}
        }),
        created(){
            var error = 'E';

            axios.post(`${BASE_URI}administrador/informe-poliza-renovar/cargaGeneral`)
                 .then((r)=>{
                     if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                     if(_.size(_.get(r,['data','data'],[])) == 0) { error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion) }
                        this.$set(this,'listGeneral',r.data.data.listas);
                        this.$set(this,'parametros',r.data.data.parametros);
                        this.obSearch.idEstado = _.toString(this.parametros.id_estado_default);
                        this.obSearch.diasVencer = _.get(this.listGeneral,['listDiasVencer','0','value'],'15');

                        this.onListar('L');

                 })
                 .catch((e)=>{
                    mensajesAlerta(e,error);
                 });
        },
        watch:{
            idTipoBusqueda(val){
                this.listGeneral.listDetalle = [];
                this.listGeneral.detalleResumen = [];
            },
            showDet(val){
                this.obModal.open = val;
            }
        },
        computed:{
            cabecera(){
                return this.idTipoBusqueda == 'P' ? _.get(this.listGeneral,'cabeceraPoliza',[]) : _.get(this.listGeneral,'cabeceraCertificado',[]);
            },
            colspan(){
                var key = this.idTipoBusqueda == 'P' ? 'cabeceraPoliza' : 'cabeceraCertificado';
                var n = _.size(_.get(this.listGeneral,key,[]));
                return n > 3 ? (n - 4) : 1
            },
            totalAsegurado(){
                var s = _.sumBy(_.get(this.listGeneral,'listDetalle',[]),(v)=>{  return _.toNumber(v.valor) });
                return _.isNaN(s) ? 0 : s;
            },
            totalPrima(){
                var s = _.sumBy(_.get(this.listGeneral,'listDetalle',[]),(v)=>{  return _.toNumber(v.prima) });
                return _.isNaN(s) ? 0 : s;
            }
        },
        methods:{
            onListar(event){
                if(!_.isUndefined(event)){
                    try {
                        if(_.size(this.obSearch.diasVencer) == 0) throw 'Debe seleccionar los dias por vencer';
                            this.disabled = true;
                            var error = 'E';
                            var o = _.merge(
                                            { opcion:`LISTAR_${this.idTipoBusqueda}`,idTipoBusqueda:this.idTipoBusqueda},
                                            _.omit(this.obSearch,['search'])
                                            );
        
                            this.$set(this.listGeneral,'listDetalle',[]);
                            this.$set(this.listGeneral,'detalleResumen',[]);
        
                            axios.post(`${BASE_URI}administrador/informe-poliza-renovar/listar`,o)
                                .then((r)=>{
                                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                    if(_.size(_.get(r,['data','data','list'],[])) == 0) { error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion) }
                                        this.$set(this.listGeneral,'listDetalle',r.data.data.list);
                                        this.$set(this.listGeneral,'detalleResumen',r.data.data.det);
                                        this.disabled = false;
                                })
                                .catch((e)=>{
                                    mensajesAlerta(e,error);
                                    this.disabled = false;
                                });    
                    } catch (ex) {
                        mensajesAlerta(ex,'I');
                    }

                }
            },
            close(){
                this.obModal.open = false;
                this.showDet = false;
            }
        },
        provide(){
            return{
                close:this.close
            }
        }
    }
</script>
